/**
 * Size Gate
 * Forces customer to actively select a size before adding to cart.
 * Adds a "Valitse koko" placeholder to the size dropdown, clears
 * the variant ID input, and disables ALL add-to-cart buttons
 * (native + pack selector) until a real size is chosen.
 * Works with Horizon 3.3.1 variant-picker component.
 */
(function() {
  'use strict';

  var PLACEHOLDER_TEXT = 'Valitse koko';
  var BUTTON_TEXT_SELECT = 'Valitse koko';
  var BUTTON_TEXT_SOLD_OUT = 'Loppuunmyyty';

  function initSizeGate() {
    // Find the variant picker on product page
    var picker = document.querySelector('variant-picker');
    if (!picker) return false;

    // Find the size select (skip color — color is handled separately)
    var selects = picker.querySelectorAll('.variant-option--dropdowns select');
    var sizeSelect = null;

    selects.forEach(function(sel) {
      var label = sel.closest('.variant-option')?.querySelector('label');
      if (!label) return;
      var labelText = label.textContent.trim().toLowerCase();
      if (labelText === 'koko' || labelText === 'size' || labelText === 'koko/size') {
        sizeSelect = sel;
      }
    });

    // If using button/swatch style instead of dropdown, handle radio inputs
    var sizeFieldset = null;
    if (!sizeSelect) {
      var fieldsets = picker.querySelectorAll('.variant-option--buttons');
      fieldsets.forEach(function(fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;
        var text = legend.textContent.trim().toLowerCase();
        if (text.indexOf('koko') !== -1 || text === 'size') {
          sizeFieldset = fs;
        }
      });
    }

    if (!sizeSelect && !sizeFieldset) return false;

    // Find the product form's hidden variant ID input
    var productForm = document.querySelector('product-form-component, [data-product-form]');
    var variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var originalVariantId = variantInput ? variantInput.value : '';

    // Find the native add-to-cart button
    var addToCartComponent = document.querySelector('add-to-cart-component');
    var nativeAddBtn = addToCartComponent ? addToCartComponent.querySelector('button[name="add"]') : null;
    var nativeAddBtnTextEl = nativeAddBtn ? nativeAddBtn.querySelector('.add-to-cart-text__content span span') : null;
    var originalBtnText = nativeAddBtnTextEl ? nativeAddBtnTextEl.textContent.trim() : '';

    // Find the pack selector's add-to-cart button.
    // Skooppi kuten `bisAnchor` alla — quick-add-modaali renderoi tuotesivun
    // ilman section-kaaretta, joten `document`-haku osuisi TAUSTASIVUN nappiin.
    var packScope = (productForm && productForm.closest('.shopify-section, #quick-add-modal-content')) || document;
    var packAddBtn = packScope.querySelector('[data-pack-add-to-cart]');
    var packAddTextEl = packAddBtn ? packAddBtn.querySelector('[data-pack-add-text]') : null;

    // --- Back in Stock: saatavuuskartta ja ankkuri -------------------------
    // `product-information` EI renderoidu uudelleen kokovalinnasta (todennettu
    // selaimella 7.10.2026: `variant:update` laukeaa, Section Rendering -pyyntoa
    // ei tule). Siksi JS omistaa seka napin tilan etta ankkurin nakyvyyden.
    //
    // Skooppi: pack-selector elaa myos quick-add-modaalissa, joten elementit
    // haetaan saman juuren sisalta kuin variantInput — `document`-haku osuisi
    // taustasivun tuotteeseen (sama ansa kuin quick-add-modaalin kanssa jo
    // kerran tuotannossa).
    var scope = (productForm && productForm.closest('.shopify-section, #quick-add-modal-content')) || document;
    var bisAnchor = scope.querySelector('[data-pack-bis]');

    // Saatavuuden LÄHDE: `variant:update` -tapahtuman `detail.resource`.
    // Todennettu selaimella 7.10.2026 — tapahtuma kantaa `{id, available}`
    // valmiina ja laukeaa vasta kun Horizon on paivittanyt variantti-inputin.
    // Siksi ei JSON-karttaa eika setTimeout-arvailua: kysytaan totuus silta
    // tapahtumalta joka sen tietaa.
    //
    // Fail open: ennen ensimmaista tapahtumaa (ja jos `available` puuttuu)
    // mitaan ei piiloteta. Ostamisen estaminen puuttuvan datan takia olisi
    // pahempi vika kuin nakymaton BIS-nappi.
    // Alkutila Liquidista: sivulatauksella `?variant=`-parametrilla
    // `variant:update` ei valttamatta laukea lainkaan, joten ankkuri jaisi
    // piiloon. Pack-selector merkitsee palvelimen tietaman saatavuuden
    // `data-initial-available` -attribuuttiin.
    var currentAvailable = null;
    if (bisAnchor && bisAnchor.dataset.initialAvailable) {
      currentAvailable = bisAnchor.dataset.initialAvailable === 'true';
    }

    function isSoldOut() {
      return currentAvailable === false;
    }

    function setGated(gated) {
      // Clear or restore the variant ID input — this is the key mechanism
      // that prevents both native and pack selector from adding to cart
      if (variantInput) {
        if (gated) {
          variantInput.value = '';
          variantInput.dataset.sizeGated = 'true';
        } else {
          // Don't restore here — Horizon's variant:update will set the correct ID
          variantInput.dataset.sizeGated = 'false';
        }
      }

      // Sticky bar: its variant line is server-rendered from the first variant,
      // so it named a size (S) nobody had chosen. The bar swaps in "Valitse
      // koko" while this flag is set (sections/product-information.liquid).
      var stickyBar = document.querySelector('sticky-add-to-cart');
      if (stickyBar) {
        stickyBar.dataset.sizeGated = gated ? 'true' : 'false';
      }

      // Disable/enable native add-to-cart button
      if (nativeAddBtn) {
        nativeAddBtn.disabled = gated;
      }
      if (nativeAddBtnTextEl) {
        nativeAddBtnTextEl.textContent = gated ? BUTTON_TEXT_SELECT : originalBtnText;
      }
      var cartIcon = nativeAddBtn ? nativeAddBtn.querySelector('.add-to-cart-icon') : null;
      if (cartIcon) {
        cartIcon.style.display = gated ? 'none' : '';
      }

      // Pakettivalitsimen nappi: EI kirjoiteta tassa. applySoldOutState
      // asettaa sen tekstin ja disabled-tilan kaikissa kolmessa tilassa, joten
      // erillinen `packAddBtn.disabled = gated` oli paitsi turha myos
      // vikaluokan lahde — se jatti loppuunmyydyn tilan huomiotta ja naytti
      // vaaraa tekstia siihen asti kunnes applySoldOutState korjasi sen.
      // Yksi kirjoittaja per nappi.
      applySoldOutState(gated);
    }

    /**
     * Kolme tilaa:
     *   gated    — kokoa ei valittu  → "Valitse koko" (disabloitu), ei ankkuria
     *   soldOut  — koko valittu, loppu → ankkuri napin tilalla
     *   ready    — koko valittu, saatavilla → normaali ostonappi
     *
     * Kutsutaan sekä setGated()-polusta etta `variant:update`-tapahtumasta,
     * koska kokovaihto ei aina kulje size-gaten oman change-kuuntelijan kautta
     * (varinvaihto, pakettivalitsimen tiilet).
     */
    function applySoldOutState(gated) {
      if (!bisAnchor && !packAddBtn) return;

      var soldOut = !gated && isSoldOut();

      if (bisAnchor) {
        bisAnchor.hidden = !soldOut;
        // Nollaa inline-display: jos piilotuslogiikka on joskus osunut tahan
        // ankkuriin, `style.display='none'` jaisi paalle ja yliajaisi
        // `hidden=false` -tilan. Tama on viimeinen sana ankkurin
        // nakyvyydesta.
        if (soldOut) bisAnchor.style.display = '';
        // Variantti luetaan DOMista, ei muistista: lazy hydration -oppi.
        var currentId = variantInput ? variantInput.value : '';
        if (soldOut && currentId) bisAnchor.dataset.variantId = currentId;
      }
      // Ostonappi JAA NAKYVIIN loppuunmyydylla koolla — se kertoo tilan
      // ("Loppuunmyyty") ja BIS-nappi sen alla tarjoaa toiminnon. Aiemmin
      // nappi piilotettiin, jolloin asiakkaalta katosi tieto SIITA MIKSI
      // ostaminen ei onnistu.
      //
      // Teksti vaihdetaan: "Lisaa ostoskoriin" olisi harhaanjohtava kun
      // nappi on disabloitu. `pack-selector.js` ei itse paivita tekstia
      // kokovalinnasta, joten se tehdaan tassa.
      if (packAddBtn) {
        packAddBtn.style.display = '';
        packAddBtn.disabled = gated || soldOut;
      }
      // Teksti asetetaan AINA, kaikissa kolmessa tilassa. Aiemmin se
      // asetettiin vain `soldOut`-haarassa, jolloin "Loppuunmyyty" jai
      // jumiin kun kayttaja vaihtoi saatavaan kokoon — saatavilla olevaa
      // tuotetta ei voinut ostaa. `variant:update` kutsuu tata suoraan
      // ohi setGatedin, joten palautus on tehtava tassa.
      if (packAddTextEl) {
        if (soldOut) {
          packAddTextEl.textContent = BUTTON_TEXT_SOLD_OUT;
        } else if (gated) {
          packAddTextEl.textContent = BUTTON_TEXT_SELECT;
        } else {
          packAddTextEl.textContent = packLabelForSelection();
        }
      }
    }

    /**
     * The pack button's label depends on the selected tier ("Lisää 5 kpl
     * ostoskoriin"), and pack-selector.js only recomputes it when a tier is
     * clicked — never when a size is chosen. Capturing the label at init is no
     * good either: the block hydrates late, so the text is still the Liquid
     * default "Valitse koko", which is what used to get restored here and left
     * the button lying about its state. So derive it from the DOM instead.
     */
    function packLabelForSelection() {
      var selected = packScope.querySelector(
        '.pack-selector__option--selected[data-pack-quantity]'
      );
      var quantity = selected ? parseInt(selected.dataset.packQuantity, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      return quantity > 1 ? 'Lis\u00E4\u00E4 ' + quantity + ' kpl ostoskoriin' : 'Lis\u00E4\u00E4 ostoskoriin';
    }

    if (sizeSelect) {
      // Dropdown mode: add placeholder option
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = PLACEHOLDER_TEXT;
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.dataset.placeholder = 'true';
      sizeSelect.insertBefore(placeholder, sizeSelect.firstChild);

      // Deselect any pre-selected option
      Array.from(sizeSelect.options).forEach(function(opt) {
        if (!opt.dataset.placeholder) {
          opt.selected = false;
        }
      });
      placeholder.selected = true;

      // Gate everything
      setGated(true);

      // Listen for size selection
      sizeSelect.addEventListener('change', function() {
        var isPlaceholder = sizeSelect.value === '' || sizeSelect.selectedOptions[0]?.dataset.placeholder;
        setGated(isPlaceholder);
      });

    } else if (sizeFieldset) {
      // Button/swatch mode: uncheck all radios
      var radios = sizeFieldset.querySelectorAll('input[type="radio"]');
      radios.forEach(function(radio) {
        radio.checked = false;
        radio.dataset.currentChecked = 'false';
        radio.dataset.previousChecked = 'false';
      });

      // Gate everything
      setGated(true);

      // Listen for radio selection
      sizeFieldset.addEventListener('change', function() {
        var anyChecked = Array.from(radios).some(function(r) { return r.checked; });
        setGated(!anyChecked);
      });
    }

    // Size-gaten oma `change`-kuuntelija ajaa ENNEN kuin Horizon on
    // paivittanyt variantin, joten saatavuutta ei voi lukea silloin. Totuus
    // saapuu `variant:update`-tapahtumassa valmiina — paivitetaan tila siita.
    // Kattaa samalla polut jotka eivat kulje size-gaten changen kautta:
    // varinvaihdon ja pakettivalitsimen tiilet.
    // KANTAVA INVARIANTTI — ala lisaa tahan early returnia.
    //
    // `pack-selector.js` kuuntelee samaa tapahtumaa ja voi ajaa ENNEN tata,
    // jolloin sen `enableIfVariant()` lukee ankkurista vielä EDELLISEN
    // variantin tilan. Tilanne korjaantuu vain siksi, etta tama kuuntelija
    // ajetaan aina ja kirjoittaa applySoldOutStaten kautta seka napin
    // tekstin, disabled-tilan etta ankkurin nakyvyyden — viimeinen kirjoitus
    // voittaa. Jos tama haara joskus palaa aikaisin, kilpatilanne herää.
    document.addEventListener('variant:update', function(event) {
      var resource = event.detail && event.detail.resource;
      if (resource && typeof resource.available === 'boolean') {
        currentAvailable = resource.available;
      }
      // Fail CLOSED: asettamaton attribuutti tarkoittaa "portti kiinni".
      // `variant:update` voi laueta ENNEN kuin setGated(true) on ehtinyt
      // asettaa attribuutin — silloin `=== 'true'` antaisi false ja ankkuri
      // valahtaisi nakyviin vaikka kokoa ei ole valittu. Ankkurin kohdalla
      // turvallinen oletus on piilossa (toisin kuin ostonapin kohdalla,
      // jossa fail-open estaa myynnin katoamisen).
      var stillGated = variantInput ? variantInput.dataset.sizeGated !== 'false' : true;
      applySoldOutState(stillGated);
    });

    // --- Klaviyon napin renderointi ----------------------------------------
    // Klaviyon dokumentaatio (help.klaviyo.com/hc/en-us/articles/38767539287323):
    //
    //   "Add this attribute to the specific HTML element where you want the
    //    'Notify me' button to be rendered, and Klaviyo will then display the
    //    button at that location INSTEAD OF the default location."
    //
    // Klaviyo siis RENDEROI nappinsa ankkurin paikalle — se ei luo erillista
    // nappia sen viereen. Kahden napin ilmio johtui siita etta ankkurissamme
    // oli oma Liquid-teksti JA Klaviyo renderoi oman nappinsa samaan kohtaan.
    //
    // Ratkaisu: ankkuri jatetaan TYHJAKSI. Klaviyo tayttaa sen. Teksti tulee
    // Klaviyon lomakkeen `dynamic_button.label`-kentasta, joka on jo
    // "Ilmoita kun saatavilla".
    //
    // Nakyvyyden omistaa edelleen size-gate (kolme tilaa), koska Klaviyon
    // nappi ei tunne kokovalintaa lainkaan.

    // Also re-find pack selector button if it initializes later (polling)
    var packPollCount = 0;
    var packPoll = setInterval(function() {
      packPollCount++;
      if (packPollCount > 20) { clearInterval(packPoll); return; }
      if (!packAddBtn) {
        packAddBtn = packScope.querySelector('[data-pack-add-to-cart]');
        packAddTextEl = packAddBtn ? packAddBtn.querySelector('[data-pack-add-text]') : null;
        if (packAddBtn && variantInput) {
          // The block may hydrate after a size was already picked, so apply the
          // current state rather than assuming the gate is still closed.
          //
          // Kierratetaan applySoldOutState kautta: aiemmin tama haara kirjoitti
          // tekstin ja disabled-tilan itse, eika tiennyt loppuunmyydysta —
          // loppuneelle koolle nappi sanoi "Lisaa ostoskoriin" ja oli aktiivinen.
          // Sama vikaluokka kuin pakettilaatan klikkauksessa (7.10.2026).
          applySoldOutState(variantInput.dataset.sizeGated !== 'false');
        }
      } else {
        clearInterval(packPoll);
      }
    }, 500);

    return true;
  }

  // Poll for variant picker (lazy hydration)
  var attempts = 0;
  var maxAttempts = 60;
  var pollTimer = setInterval(function() {
    attempts++;
    if (initSizeGate() || attempts >= maxAttempts) {
      clearInterval(pollTimer);
    }
  }, 500);
})();
